import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import React, { useState } from "react";

export const EmojiPicker: React.FC<{ open: boolean; onEmojiSelect: (emoji: any) => void; onClose: () => void }> = (props) => {
    const { open, onEmojiSelect, onClose } = props;
    const [openEmoji, setOpenEmoji] = useState(open);
    React.useEffect(() => {
        setOpenEmoji(open);
    }, [open]);

    if (!openEmoji) {
        return <div />;
    }
    return (
        <div>
            <div
                className="absolute lg:block md:block z-50"
                style={{
                    transform: "translate3d(30px, -200px, 0px)",
                    // transform:"translate3d(-150px, -460px, 0px)" //top
                    // transform: "translate3d(-150px, 5px, 0px)" //bottom
                }}
            >
                <Picker data={data} title="Pick an emoji" onEmojiSelect={onEmojiSelect} />
            </div>
            <div className={"fixed top-0 bottom-0 left-0 right-0 h-full w-full bg-transparent"} onClick={onClose}></div>
        </div>
    );
};
